/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListPresetsPresetType } from './listPresetsPresetType';
import type { ListPresetsSelector } from './listPresetsSelector';
import type { ListPresetsVisibility } from './listPresetsVisibility';

export type ListPresetsParams = {
preset_type?: ListPresetsPresetType;
search?: string | null;
visibility?: ListPresetsVisibility;
selector?: ListPresetsSelector;
creator_id?: string | null;
creator_id_not?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
};
